import React, { useEffect, useState } from 'react';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { Modal } from 'antd';
import { reset } from 'app/entities/checkIn/checkIn-year.reducer';
import { getBoxWorkStatus } from 'app/entities/common/common.reducer';
import { KrTypes } from 'app/shared/model/enum/kr.enum';
import ReportQualitativeResult from './reportQualitativeResult';
import ReportQuantitativeResult from './reportQuantitativeResult';
import * as _ from 'lodash';
import { getListKrCheckInYear } from 'app/entities/checkIn/checkIn-year.reducer';
type IReportQualitativeResult = {
  isOpen: boolean;
  onClose: (isReload?: boolean) => void;
  krSelected?: any;
  isReadOnly?: boolean;
};

export const ReportKr = ({ isOpen, onClose, krSelected, isReadOnly }: IReportQualitativeResult) => {
  const dispatch = useAppDispatch();
  const filters = useAppSelector(state => state.filters.orgCheckIn);
  const entities = useAppSelector(state => state.checkInYear.entities);
  const [krCheckIns, setKrCheckIns] = useState([])
  const [krInfo, setKrInfo] = useState(null)
  const [demKr, setDemKr] = useState(null)
  const [isUpdateSuccess, setUpdateSuccess] = useState(false);

  const handleClose = (isReload = undefined) => {
    dispatch(reset());
    onClose(isReload ?? isUpdateSuccess);
  };

  useEffect(() => {
    dispatch(getBoxWorkStatus({ statusType: 1 }));
    if (krSelected?.id) {
      handleGetListKrCheckInYear();
    }

  }, [filters, krSelected]);

  useEffect(() => {
    if (entities && entities.length > 0) {
      setKrCheckIns(entities);
      const index = _.findIndex(entities, (e: any) => {
        return e.nextCheckinId === krSelected?.id;
      }, 0);
      setDemKr(index);
    }
  }, [entities])

  useEffect(() => {
    if (krCheckIns && krCheckIns.length > 0 && demKr !== null && demKr >= 0) {
      if (krCheckIns[demKr])
        setKrInfo({ id: krCheckIns[demKr].nextCheckinId, krType: krCheckIns[demKr].krType });
      else {
        setDemKr(0);
        setKrInfo({ id: krCheckIns[0].nextCheckinId, krType: krCheckIns[0].krType });
      }
    }
  }, [demKr, krCheckIns])

  const handleGetListKrCheckInYear = () => {
    dispatch(getListKrCheckInYear({ krId: krSelected?.id, reportScheduleId: filters?.reportScheduleId }))
  }

  const handleNextKrCheckIn = () => {
    setDemKr((previous) => previous + 1);
  }

  return (
    <Modal
      width={1300}
      open={isOpen}
      maskClosable={false}
      footer={null}
      onCancel={() => {
        handleClose();
      }}
    >
      {krInfo?.krType === KrTypes.Qualitative ? (
        <ReportQualitativeResult krCheckIn={krInfo} isReadOnly={isReadOnly} setUpdateSuccess={setUpdateSuccess} handleNextData={handleNextKrCheckIn} handleClose={handleClose} />
      ) : (
        <ReportQuantitativeResult krCheckIn={krInfo} isReadOnly={isReadOnly} setUpdateSuccess={setUpdateSuccess} handleNextData={handleNextKrCheckIn} handleClose={handleClose} />
      )}
    </Modal>
  );
};

export default ReportKr;
